import { Component, type ErrorInfo, type ReactNode } from 'react';

import { ErrorView } from '@/views';

export type ErrorBoundaryProps = {
  children: ReactNode;
};

export type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error(
      'Caught error',
      error,
      errorInfo.digest,
      errorInfo.componentStack,
    );
  }

  render(): ReactNode {
    if (this.state.hasError) {
      //TODO: Is this were we use sentry?
      return <ErrorView code={'500'}></ErrorView>;
    }

    return this.props.children;
  }
}
